module.exports = __webpack_public_path__ + "img/bl_blue.78e423ac.png";